// progress-bar.component.ts
import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="h-6 bg-theme-surface2 rounded-lg overflow-hidden border-2 border-theme-primary">
      <div
        class="h-full bg-theme-primary transition-all duration-500 ease-out rounded"
        [style.width.%]="progress">
      </div>
    </div>
  `
})
export class ProgressBarComponent {
  @Input() progress: number = 0;
}
